import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ReactDatePicker from 'react-datepicker';
import { useLanguageContext } from 'store/language';

export interface IDatepickerProps {
  wrapperClassName?: string;
  className?: string;
  placeholder?: string;
  dateFormat?: string;
  selected?: any;
  isDateRange?: boolean;
  onChange?: any;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  showYearPicker?: boolean;
  showMonthYearPicker?: boolean;
  showTimeSelect?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
  isRequired?: boolean;
  readOnly?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  yearDropdownItemNumber?: number;
  scrollableYearDropdown?: boolean;
  dropdownMode?: 'scroll' | 'select' | undefined;
  selectsEnd?: boolean;
  selectsStart?: boolean;
  ariaLabel?: string;
  showTimeSelectOnly?: boolean;
  filterDate?: (val: any) => boolean;
  timeIntervals?: number;
  testId?: string;
}

/*
 * Abstracted datepicker component through `react-datepicker`.
 */
const Datepicker: FC<IDatepickerProps> = ({
  wrapperClassName,
  className,
  placeholder,
  dateFormat,
  selected,
  filterDate,
  isDateRange,
  onChange,
  startDate,
  endDate,
  minDate,
  maxDate,
  showYearPicker,
  showMonthYearPicker,
  showTimeSelect,
  showMonthDropdown,
  showYearDropdown,
  isRequired,
  readOnly,
  isClearable,
  yearDropdownItemNumber,
  scrollableYearDropdown,
  dropdownMode,
  selectsEnd,
  selectsStart,
  ariaLabel,
  showTimeSelectOnly,
  timeIntervals,
  testId,
}) => {
  const { t } = useTranslation();
  const { language } = useLanguageContext();

  return (
    <div data-testid={testId}>
      <ReactDatePicker
        wrapperClassName={wrapperClassName}
        className={className}
        locale={language || 'bg'}
        timeCaption={t('form.time')}
        placeholderText={placeholder}
        onMonthChange={onChange}
        onChange={onChange}
        selected={selected}
        filterDate={filterDate}
        selectsRange={isDateRange}
        required={isRequired}
        readOnly={readOnly}
        dateFormat={dateFormat}
        showTimeSelect={showTimeSelect}
        showYearPicker={showYearPicker}
        showMonthYearPicker={showMonthYearPicker}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        yearItemNumber={6}
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
        isClearable={isClearable}
        yearDropdownItemNumber={yearDropdownItemNumber}
        scrollableYearDropdown={scrollableYearDropdown}
        dropdownMode={dropdownMode}
        selectsEnd={selectsEnd}
        selectsStart={selectsStart}
        ariaLabelledBy={ariaLabel}
        showTimeSelectOnly={showTimeSelectOnly}
        timeIntervals={timeIntervals}
      />
    </div>
  );
};

export default Datepicker;
